import { useEffect, useCallback } from 'react'
import { debounce } from 'lodash'
import { useDispatch } from 'react-redux'
import { setLoading } from 'state/loading'

const useGlobalLoader = loading => {
  const dispatch = useDispatch()
  const dispatchLoading = useCallback(payload => dispatch(setLoading(payload)), [])
  const debouncedDispatchLoading = useCallback(debounce(dispatchLoading, 100), [])

  useEffect(() => {
    debouncedDispatchLoading(loading)
  }, [loading])

  return null
}

export default useGlobalLoader
